import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import for internal navigation
import { useTranslation } from 'react-i18next'; // Use standard t() for simplicity
import { useGlobalContext } from '../hooks/useGlobalContext'; // Access theme for conditional styling

const Footer = () => {
  const { t } = useTranslation();
  const { theme } = useGlobalContext(); // Get current theme (light/dark)

  return (
    <footer 
      className={`py-4 mt-5 ${theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`} 
      style={{ borderTop: '1px solid #dee2e6' }} // Subtle top border for separation
    >
      <Container fluid>
        <Row className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
          {/* Copyright Section: Left on desktop, top on mobile */}
          <Col xs={12} lg="auto" className="text-center text-lg-start mb-3 mb-lg-0">
            <small className="text-muted">
              {/* Updated: Split copyright into prefix, link, and suffix for reliable i18n and rendering */}
              {t('footer.copyrightPrefix', { year: new Date().getFullYear() })}
              <a 
                href="https://www.codeqazone.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link" // Updated: Apply custom footer-link class for bold, no-underline, and hover styles
              >
                {t('footer.brandName')}
              </a>
              {t('footer.copyrightSuffix')}
            </small>
          </Col>
          
          {/* Policies Section: Right on desktop, bottom on mobile */}
          <Col xs={12} lg="auto" className="text-center text-lg-end">
            <small className="d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-end gap-3">
              <Link 
                to="/terms-of-service" // Use Link for internal SPA navigation
                className="footer-link" // Updated: Apply custom footer-link class for bold, no-underline, and hover styles
                aria-label={t('footer.termsOfService')}
              >
                {t('footer.termsOfService')}
              </Link>
              <Link 
                to="/privacy-policy" // Use Link for internal SPA navigation
                className="footer-link" // Updated: Apply custom footer-link class for bold, no-underline, and hover styles
                aria-label={t('footer.privacyPolicy')}
              >
                {t('footer.privacyPolicy')}
              </Link>
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;